import { ComponentVersions_3_0, ComponentVersionsInherit } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { Title } from 'ra-ui-materialui'

// Keep this component local to the lazy entry-point.
// dependency-cruiser forbids lazy entry-points importing implementation details from inside the chunk.
const FileName = (props) => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Title defaultTitle={`${translate('File')} ${props?.record ? `"${props.record.title}"` : ''}`} {...props} />
    </ComponentVersionsInherit>
  )
}

export const privateFiles = {
  list: { lazy: () => import('./PrivateFiles'), component: 'PrivateFileList' },
  create: { lazy: () => import('./PrivateFiles'), component: 'PrivateFileCreate' },
  edit: { lazy: () => import('./PrivateFiles'), component: 'PrivateFileEdit' },
  options: {
    create: {
      title: 'Create Private File',
      subtitle: null,
      breadCrumb: 'Create Private File',
    },
    list: {
      title: 'Private Files',
      subtitle: null,
      breadCrumb: 'Private Files',
    },
    edit: {
      title: <FileName />,
      subtitle: null,
      breadCrumb: 'Edit Private File',
    },
  },
}

export const publicFiles = {
  list: { lazy: () => import('./PublicFiles'), component: 'PublicFileList' },
  create: { lazy: () => import('./PublicFiles'), component: 'PublicFileCreate' },
  edit: { lazy: () => import('./PublicFiles'), component: 'PublicFileEdit' },
  options: {
    create: {
      title: 'Create Public File',
      subtitle: null,
      breadCrumb: 'Create Public File',
    },
    list: {
      title: 'Public Files',
      subtitle: null,
      breadCrumb: 'Public Files',
    },
    edit: {
      title: <FileName />,
      subtitle: null,
      breadCrumb: 'Edit Public File',
    },
  },
}

export const globalPublicFiles = {
  list: { lazy: () => import('./PublicFiles'), component: 'PublicFileList' },
  create: { lazy: () => import('./PublicFiles'), component: 'PublicFileCreate' },
  edit: { lazy: () => import('./PublicFiles'), component: 'PublicFileEdit' },
  options: {
    create: {
      title: 'Create Global Public File',
      subtitle: null,
      breadCrumb: 'Create Global Public File',
    },
    list: {
      title: 'Global Public Files',
      subtitle: null,
      breadCrumb: 'Global Public Files',
    },
    edit: {
      title: <FileName />,
      subtitle: null,
      breadCrumb: 'Edit Global Public File',
    },
  },
}
